/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminCreateOrgOptions, AdminCreateOrgResponses } from '../../models/AdminCreateOrg'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @description Create an org
 * @summary Create Org
 * {@link /admin/org/create}
 */
export function adminCreateOrg<ThrowOnError extends boolean = true>(options: Options<AdminCreateOrgOptions, ThrowOnError>): Promise<UnwrappedResult<AdminCreateOrgResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/org/create', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminCreateOrgResponses, ThrowOnError>>
}
